import { BoardData } from '../types';

export const saveData = (data: BoardData): void => {
  try {
    localStorage.setItem("kanbanData", JSON.stringify(data));
  } catch (error) {
    console.error("Error saving data to localStorage:", error);
  }
};

export const loadData = (): BoardData | null => {
  try {
    const saved = localStorage.getItem("kanbanData");
    if (saved) {
      return JSON.parse(saved);
    }
    return null;
  } catch (error) {
    console.error("Error loading data from localStorage:", error);
    return null;
  }
};
